//#region TerminalType
export enum TerminalType_Enum {
  Driver = 0,
  Counter = 1,
  Kiosk = 2,
  PassengerApp = 3,
  Company = 4,
  Pos = 5,
  Offline = 6,
  CallSale = 7,
  Panel = 8,
}

export const TerminalType_Display: { [index: number]: string } = {
  [TerminalType_Enum.Driver]: "راننده ",
  [TerminalType_Enum.Counter]: "کانتر ",
  [TerminalType_Enum.Kiosk]: "کیوسک",
  [TerminalType_Enum.PassengerApp]: "اپلیکیشن",
  [TerminalType_Enum.Company]: "شرکت",
  [TerminalType_Enum.Pos]: "Pos",
  [TerminalType_Enum.Offline]: "آفلاین",
  [TerminalType_Enum.CallSale]: "تلفنی",
};

//#endregion

//#region TransactionType
export enum TransactionType_Enum {
  DriverCharge = 1,
  TripRequest = 2,
}

export const TransactionType_Display: { [index: number]: string } = {
  [TransactionType_Enum.DriverCharge]: "شارژ راننده",
  [TransactionType_Enum.TripRequest]: "کیوسک",
};

//#endregion

//#region VehiclePlaqueType
export enum VehiclePlaqueType_Enum {
  personal = 0,
  old = 1,
  taxi = 2,
  agriculture = 3,
  governmental = 4,
  police = 5,
  transportation = 6,
  temporary = 7,
  motor = 8,
  historical = 9,
  formality = 10,
  political = 11,
  disabledPeople = 12,
  freeZone = 13,
  suburbanTaxi = 14,
}

export const VehiclePlaqueType_Dispaly: { [index: number]: string } = {
  [VehiclePlaqueType_Enum.personal]: "شخصی",
  [VehiclePlaqueType_Enum.old]: "قدیمی",
  [VehiclePlaqueType_Enum.taxi]: "تاکسی",
  [VehiclePlaqueType_Enum.agriculture]: "کشاورزی",
  [VehiclePlaqueType_Enum.governmental]: "دولتی",
  [VehiclePlaqueType_Enum.police]: "پلیس",
  [VehiclePlaqueType_Enum.transportation]: "حمل و نقل عمومی",
  [VehiclePlaqueType_Enum.temporary]: "گذر موقت",
  [VehiclePlaqueType_Enum.motor]: "موتور",
  [VehiclePlaqueType_Enum.historical]: "تاریخی",
  [VehiclePlaqueType_Enum.formality]: "تشریفات",
  [VehiclePlaqueType_Enum.political]: "سیاسی",
  [VehiclePlaqueType_Enum.disabledPeople]: "معلولین",
  [VehiclePlaqueType_Enum.freeZone]: "منطقه ازاد",
  [VehiclePlaqueType_Enum.suburbanTaxi]: "تاکسی برون شهری ",
};
//#endregion

//#region SalePaymentMethod
export enum SalePaymentMethod_Enum {
  cashToSeller = 1,
  cashToDriver = 2,
  androidPos = 3,
  link = 4,
  cashToCompany = 5,
  wallet = 6,
  //Pc Pose
  pCPos = 7,
}

export const SalePaymentMethod_Dispaly: { [index: number]: string } = {
  [SalePaymentMethod_Enum.cashToSeller]: "نقدی به فروشنده",
  [SalePaymentMethod_Enum.cashToDriver]: "نقدی به راننده",
  [SalePaymentMethod_Enum.androidPos]: "اندروید پوز ",
  [SalePaymentMethod_Enum.link]: "لینک پرداخت ",
  [SalePaymentMethod_Enum.cashToCompany]: "نقدی به شرکت ",
  [SalePaymentMethod_Enum.wallet]: "اعتباری",
  [SalePaymentMethod_Enum.pCPos]: "پوز",
};
//#endregion

//#region TripOptionType
export enum TripOptionType_Enum {
  ExtraDestination = 1,
  StopMinute = 2,
  ExtraBaggage = 3,
  BaggageTransportaion = 4,
}

export const TripOptionType_Display: { [index: number]: string } = {
  [TripOptionType_Enum.ExtraDestination]: "مقصد اضافه",
  [TripOptionType_Enum.StopMinute]: "توقف",
  [TripOptionType_Enum.ExtraBaggage]: "چمدان اضافه",
  [TripOptionType_Enum.BaggageTransportaion]: "حمل چمدان",
};
//#endregion

//#region TripStatus

export enum TripStatus_Enum {
  Registered = 1,
  InStation = 2,
  InMission = 3,
  EndMission = 4,
  Cancel = 5,
  GetToSource = 6,
  AcceptTrip = 7,
  AcceptReserve = 8,
  MoveToPassenger = 9,
  EnterToThePassengerPool = 10,
  AutoSearchForDriver = 11,
  FinalAcceptTrip = 12,
  PendingToPassengerPool = 13,
}

export const TripStatus_Display: { [index: number]: string } = {
  [TripStatus_Enum.Registered]: "ثبت شده",
  [TripStatus_Enum.InStation]: "در سکو",
  [TripStatus_Enum.InMission]: "در حال سفر",
  [TripStatus_Enum.EndMission]: "پایان سفر",
  [TripStatus_Enum.Cancel]: "لغو",
  [TripStatus_Enum.GetToSource]: "به مبدا رسیدم",
  [TripStatus_Enum.AcceptTrip]: "قبول سفر",
  [TripStatus_Enum.AcceptReserve]: "تایید راننده » رزرو اولیه",
  [TripStatus_Enum.MoveToPassenger]: "حرکت به سمت مسافر",
  [TripStatus_Enum.EnterToThePassengerPool]: "درج سالن مسافر",
  [TripStatus_Enum.AutoSearchForDriver]: "جستجو راننده",
  [TripStatus_Enum.FinalAcceptTrip]: "تایید راننده » رزرو نهایی",
  [TripStatus_Enum.PendingToPassengerPool]: "درانتظار ورود به سالن مسافر",
};

export const TripStatusDriver_Display: { [index: number]: string } = {
  [TripStatus_Enum.Registered]: "ثبت شده",
  [TripStatus_Enum.InStation]: "در سکو",
  [TripStatus_Enum.InMission]: "در حال سفر",
  [TripStatus_Enum.EndMission]: "پایان سفر",
  [TripStatus_Enum.Cancel]: "لغو",
  [TripStatus_Enum.GetToSource]: "تاکسی رسید  ",
  [TripStatus_Enum.AcceptTrip]: "اعزام راننده",
  [TripStatus_Enum.AcceptReserve]: "تایید راننده » رزرو اولیه",
  [TripStatus_Enum.MoveToPassenger]: "راننده به سوی شما حرکت کرد",
  [TripStatus_Enum.EnterToThePassengerPool]: "درج سالن مسافر",
  [TripStatus_Enum.AutoSearchForDriver]: "جستجو راننده",
  [TripStatus_Enum.FinalAcceptTrip]: "تایید راننده » رزرو نهایی",
  [TripStatus_Enum.PendingToPassengerPool]: "درانتظار ورود به سالن مسافر",
};
//#endregion

//#region TripOptionStatus
export enum TripOptionStatus_Enum {
  NotRegistered = 0,
  Pending = 1,
  Approved = 2,
  PassengerDeleted = 4,
  TemporaryRegistration = 5,
}

export const TripOptionStatus_Display: { [index: number]: string } = {
  [TripOptionStatus_Enum.NotRegistered]: "ثبت نشده",
  [TripOptionStatus_Enum.Pending]: "در انتظار تایید راننده",
  [TripOptionStatus_Enum.Approved]: "تایید شده",
  [TripOptionStatus_Enum.PassengerDeleted]: "توسط مسافر",
  [TripOptionStatus_Enum.TemporaryRegistration]: "ثبت موقت",
};
//#endregion

//#region TransportType
export enum TransportType_Enum {
  Terminal = 0,
  Patrol = 1,
}

export const TransportType_Display: { [index: number]: string } = {
  [TransportType_Enum.Terminal]: "ترمینالی",
  [TransportType_Enum.Patrol]: "گردشی",
};
// #endregion

//#region PaymentStep
export enum PaymentStep_Enum {
  ReSend = 1,
  PendingPrint = 2,
  RePrint = 3,
  PendingCard = 4,
  PendingFinalizing = 5,
  Success = 6,
  RePay = 7,
  ErrorFinalizing = 8,
}

export const PaymentStep_Display: { [index: number]: string } = {
  [PaymentStep_Enum.ReSend]: "ثبت درخواست مجدد",
  [PaymentStep_Enum.PendingPrint]: "در انتظار پرینت",
  [PaymentStep_Enum.RePrint]: "پرینت مجدد",
  [PaymentStep_Enum.PendingCard]: "در کشیدن کارت",
  [PaymentStep_Enum.PendingFinalizing]: "در انتظار نهایی سازی پرداخت",
  [PaymentStep_Enum.Success]: "سفر موفق ثبت شده",
  [PaymentStep_Enum.RePay]: "پرداخت مجدد",
  [PaymentStep_Enum.ErrorFinalizing]: "نهایی سازی مجدد",
};

// #endregion

export enum POSType_Enum {
  //به پرداخت ملت
  Beh_Pardakht = 1,

  //سپهر
  Sepehr = 0,
}
